// extracted by mini-css-extract-plugin
export var root = "z_t2";
export var wrapper = "z_t3";
export var image = "z_t4 d_w d_y d_W";
export var imageWithHeight = "z_t5";
export var crop = "z_t6";
export var round = "z_t7";
export var fixedHeight = "z_t8";